<template>
  <n-tooltip v-if="date" position="top" :text="actualDate">
    <span>
      {{ relativeDate }}
    </span>
  </n-tooltip>
  <span v-else :class="{ 'is-unknown': isUnknown }">
    {{ relativeDate }}
  </span>
</template>

<script lang="ts" setup>
import moment from 'moment';
import { computed } from 'vue';

const props = defineProps({
  date: {
    type: [String, Date],
  },
  placeholder: {
    type: String,
    default: 'never',
  },
});

const actualDate = computed(() => moment(props.date).format('lll'));
const relativeDate = computed(() => (!props.date ? props.placeholder : moment(props.date).fromNow()));
const isUnknown = computed(() => !props.date && props.placeholder !== 'never');
</script>

<style scoped lang="scss">
.is-unknown {
  opacity: 0.7;
}
</style>
